﻿import React from 'react';
import {styled} from '@mui/system';
import {IconButton, IconButtonProps} from "@mui/material";
import {Add, Remove} from "@mui/icons-material";

const Root = styled(IconButton)(() => ({
  padding: '0em'
}));

type CollapsableCardExpandIconButtonProps = Omit<IconButtonProps, 'children'> & {
  expanded: boolean
}

const CollapsableCardExpandIconButton = ({expanded, ...rest}: CollapsableCardExpandIconButtonProps) => {
  return <Root aria-label={expanded ? 'Collapse card' : 'Expand card'} {...rest}>
    {
      expanded ? (<Remove fontSize={'medium'} color={'primary'} />)
        : (<Add fontSize={'medium'} color={'primary'} />)
    }
  </Root>
}

export { CollapsableCardExpandIconButton };